<div class="min-h-screen bg-gradient-to-br from-gray-50 to-white">
  <!-- Header Section -->
  <section class="bg-gradient-to-r from-brand-primary to-brand-accent text-white py-16">
    <div class="container mx-auto px-4">
      <h1 class="text-5xl font-bold mb-4 text-center">Impressum</h1>
      <p class="text-xl text-center opacity-90">
        Angaben gemäß § 5 TMG
      </p>
    </div>
  </section>

  <!-- Imprint Content -->
  <section class="py-16">
    <div class="container mx-auto px-4">
      <div class="max-w-4xl mx-auto">
        
        <!-- Company Information -->
        <div class="bg-white rounded-2xl shadow-lg p-8 mb-8 border border-gray-100">
          <h2 class="text-3xl font-bold mb-6 text-brand-primary">Firmeninformationen</h2>
          
          <div class="space-y-4 text-gray-700">
            <div>
              <h3 class="font-bold text-lg text-gray-900 mb-2">{{ companyInfo.name }}</h3>
              <p>{{ companyInfo.street }}</p>
              <p>{{ companyInfo.zip }} {{ companyInfo.city }}</p>
              <p>{{ companyInfo.country }}</p>
            </div>

            <div class="pt-4 border-t border-gray-200">
              <div class="grid md:grid-cols-2 gap-4">
                <div>
                  <p class="font-semibold text-gray-900">Telefon:</p>
                  <p>{{ companyInfo.phone }}</p>
                </div>
                <div>
                  <p class="font-semibold text-gray-900">E-Mail:</p>
                  <p><a href="mailto:{{ companyInfo.email }}" class="text-brand-accent hover:underline">{{ companyInfo.email }}</a></p>
                </div>
                <div>
                  <p class="font-semibold text-gray-900">Website:</p>
                  <p>{{ companyInfo.web }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Legal Information -->
        <div class="bg-white rounded-2xl shadow-lg p-8 mb-8 border border-gray-100">
          <h2 class="text-3xl font-bold mb-6 text-brand-primary">Rechtliche Angaben</h2>
          
          <div class="space-y-4 text-gray-700">
            <div>
              <p class="font-semibold text-gray-900">Vertreten durch:</p>
              <p>{{ companyInfo.ceo }} (Inhaber)</p>
            </div>

            <div>
              <p class="font-semibold text-gray-900">Umsatzsteuer-ID:</p>
              <p>Umsatzsteuer-Identifikationsnummer gemäß § 27a Umsatzsteuergesetz:</p>
              <p>{{ companyInfo.vatId }}</p>
            </div>


          </div>
        </div>

        <!-- Responsible for Content -->
        <div class="bg-white rounded-2xl shadow-lg p-8 mb-8 border border-gray-100">
          <h2 class="text-3xl font-bold mb-6 text-brand-primary">Verantwortlich für den Inhalt</h2>
          
          <div class="text-gray-700">
            <p>Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV:</p>
            <p class="mt-2 font-semibold">{{ companyInfo.ceo }}</p>
            <p>{{ companyInfo.street }}</p>
            <p>{{ companyInfo.zip }} {{ companyInfo.city }}</p>
          </div>
        </div>

        <!-- Professional Liability Insurance -->
        <div class="bg-white rounded-2xl shadow-lg p-8 mb-8 border border-gray-100">
          <h2 class="text-3xl font-bold mb-6 text-brand-primary">Berufshaftpflichtversicherung</h2>
          
          <div class="text-gray-700 space-y-4">
            <div>
              <p class="font-semibold text-gray-900 mb-2">Versicherer:</p>
              <p>Gothaer Allgemeine Versicherung AG</p>
              <p>50598 Köln</p>
            </div>

            <div>
              <p class="font-semibold text-gray-900 mb-2">Geltungsbereich des Versicherungsschutzes:</p>
              <ul class="list-disc list-inside space-y-1 ml-4">
                <li>3.000.000 EUR pauschal für Personen- und Sachschäden</li>
                <li>300.000 EUR für Vermögensschäden</li>
              </ul>
            </div>
          </div>
        </div>

        <!-- EU Dispute Resolution -->
        <div class="bg-white rounded-2xl shadow-lg p-8 mb-8 border border-gray-100">
          <h2 class="text-3xl font-bold mb-6 text-brand-primary">EU-Streitschlichtung</h2>
          
          <div class="text-gray-700 space-y-4">
            <p>
              Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit:
              <a href="https://ec.europa.eu/consumers/odr/" target="_blank" rel="noopener noreferrer" class="text-brand-accent hover:underline ml-1">
                https://ec.europa.eu/consumers/odr/
              </a>
            </p>
            <p>
              Unsere E-Mail-Adresse finden Sie oben im Impressum.
            </p>
          </div>
        </div>

        <!-- Consumer Dispute Resolution -->
        <div class="bg-white rounded-2xl shadow-lg p-8 mb-8 border border-gray-100">
          <h2 class="text-3xl font-bold mb-6 text-brand-primary">Verbraucherstreitbeilegung / Universalschlichtungsstelle</h2>
          
          <div class="text-gray-700">
            <p>
              Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer 
              Verbraucherschlichtungsstelle teilzunehmen.
            </p>
          </div>
        </div>

        <!-- Liability for Content -->
        <div class="bg-white rounded-2xl shadow-lg p-8 mb-8 border border-gray-100">
          <h2 class="text-3xl font-bold mb-6 text-brand-primary">Haftung für Inhalte</h2>
          
          <div class="text-gray-700 space-y-4 leading-relaxed">
            <p>
              Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten 
              nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als 
              Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde 
              Informationen zu überwachen oder nach Umständen zu forschen, die auf eine 
              rechtswidrige Tätigkeit hinweisen.
            </p>
            <p>
              Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach den 
              allgemeinen Gesetzen bleiben hiervon unberührt. Eine diesbezügliche Haftung ist jedoch 
              erst ab dem Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung möglich. Bei 
              Bekanntwerden von entsprechenden Rechtsverletzungen werden wir diese Inhalte umgehend entfernen.
            </p>
          </div>
        </div>

        <!-- Liability for Links -->
        <div class="bg-white rounded-2xl shadow-lg p-8 mb-8 border border-gray-100">
          <h2 class="text-3xl font-bold mb-6 text-brand-primary">Haftung für Links</h2>
          
          <div class="text-gray-700 space-y-4 leading-relaxed">
            <p>
              Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen 
              Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. 
              Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der 
              Seiten verantwortlich. Die verlinkten Seiten wurden zum Zeitpunkt der Verlinkung auf 
              mögliche Rechtsverstöße überprüft. Rechtswidrige Inhalte waren zum Zeitpunkt der 
              Verlinkung nicht erkennbar.
            </p>
            <p>
              Eine permanente inhaltliche Kontrolle der verlinkten Seiten ist jedoch ohne konkrete 
              Anhaltspunkte einer Rechtsverletzung nicht zumutbar. Bei Bekanntwerden von 
              Rechtsverletzungen werden wir derartige Links umgehend entfernen.
            </p>
          </div>
        </div>

        <!-- Copyright -->
        <div class="bg-white rounded-2xl shadow-lg p-8 mb-8 border border-gray-100">
          <h2 class="text-3xl font-bold mb-6 text-brand-primary">Urheberrecht</h2>
          
          <div class="text-gray-700 space-y-4 leading-relaxed">
            <p>
              Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen 
              dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art 
              der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen 
              Zustimmung des jeweiligen Autors bzw. Erstellers. Downloads und Kopien dieser Seite sind 
              nur für den privaten, nicht kommerziellen Gebrauch gestattet.
            </p>
            <p>
              Soweit die Inhalte auf dieser Seite nicht vom Betreiber erstellt wurden, werden die 
              Urheberrechte Dritter beachtet. Insbesondere werden Inhalte Dritter als solche 
              gekennzeichnet. Sollten Sie trotzdem auf eine Urheberrechtsverletzung aufmerksam werden, 
              bitten wir um einen entsprechenden Hinweis. Bei Bekanntwerden von Rechtsverletzungen 
              werden wir derartige Inhalte umgehend entfernen.
            </p>
          </div>
        </div>



      </div>
    </div>
  </section>
</div>
